import React from 'react';
import { LifeBuoyIcon, ActivityIcon, DownloadIcon, VideoIcon } from 'lucide-react';
export function SupportSection() {
  const resources = [{
    title: 'Create Support Ticket',
    description: 'Need help with an order or product? Contact our team.',
    icon: <LifeBuoyIcon className="w-6 h-6" data-id="element-203" />,
    link: 'Contact Support'
  }, {
    title: 'Thresholds & Hit Levels',
    description: 'View official Daedo scoring thresholds for all age/weight classes.',
    icon: <ActivityIcon className="w-6 h-6" data-id="element-204" />,
    link: 'View Thresholds'
  }, {
    title: 'Download Software',
    description: 'Get the latest Daedo Truescore software for your system.',
    icon: <DownloadIcon className="w-6 h-6" data-id="element-205" />,
    link: 'Download Hub'
  }, {
    title: 'Troubleshooting Videos',
    description: 'Step-by-step guides for setup and common issues.',
    icon: <VideoIcon className="w-6 h-6" data-id="element-206" />,
    link: 'Watch Videos'
  }];
  return <section className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <h2 className="text-3xl font-black text-gray-900 uppercase tracking-tight" data-id="element-210">
            Support & Resources
          </h2>
          <div className="w-24 h-1 bg-gray-300 mx-auto mt-4" data-id="element-211"></div>
          <p className="mt-4 text-gray-600 font-medium max-w-2xl mx-auto" data-id="element-212">
            Get help with setup, troubleshooting, and product guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-213">
          {resources.map((resource, index) => <a key={index} href="#" className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md hover:border-blue-300 transition-all duration-200 group flex flex-col h-full" data-id="element-214">
              <div className="w-12 h-12 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center mb-4 group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors" data-id="element-215">
                {resource.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-216">
                {resource.title}
              </h3>
              <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-217">
                {resource.description}
              </p>
              <span className="text-blue-600 font-bold text-sm group-hover:underline" data-id="element-218">
                {resource.link} &rarr;
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}